import NotificationSimpleForm from './NotificationSimpleForm'

export default NotificationSimpleForm
